import * as types from "../types"; // Import your action types

// Initial state with the provided category list
const initialState = {
  categories: [
    {
      id: 1,
      name: "Exercise",
      color: {
        id: 1,
        color_code: "#F79781",
        outer_color_code: "#F32A00",
        inner_color_code: "#F79781",
      },
    },
    {
      id: 2,
      name: "Entertainment",
      color: {
        id: 2,
        color_code: "#F8CD80",
        outer_color_code: "#F79A00",
        inner_color_code: "#F8CD80",
      },
    },
    {
      id: 3,
      name: "Food",
      color: {
        id: 3,
        color_code: "#C4DD81",
        outer_color_code: "#86BB00",
        inner_color_code: "#C4DD81",
      },
    },
    {
      id: 4,
      name: "Education",
      color: {
        id: 4,
        color_code: "#94DAC1",
        outer_color_code: "#29C18C",
        inner_color_code: "#94DAC1",
      },
    },
    {
      id: 5,
      name: "Leisure",
      color: {
        id: 5,
        color_code: "#FFEDAE",
        outer_color_code: "#F5CC3B",
        inner_color_code: "#FFEDAE",
      },
    },
    {
      id: 6,
      name: "Work",
      color: {
        id: 6,
        color_code: "#8BA6C2",
        outer_color_code: "#123051",
        inner_color_code: "#8BA6C2",
      },
    },
    {
      id: 7,
      name: "Self Care",
      color: {
        id: 7,
        color_code: "#BBE6E7",
        outer_color_code: "#77CCCD",
        inner_color_code: "#BBE6E7",
      },
    },
    {
      id: 8,
      name: "Sleep",
      color: {
        id: 8,
        color_code: "#D6D7D8",
        outer_color_code: "#AAABAD",
        inner_color_code: "#D6D7D8",
      },
    },
    {
      id: 9,
      name: "Volunteering",
      color: {
        id: 9,
        color_code: "#E9ADCA",
        outer_color_code: "#E25297",
        inner_color_code: "#E9ADCA",
      },
    },
    {
      id: 10,
      name: "Faith/Spirituality",
      color: {
        id: 10,
        color_code: "#CCA3CF",
        outer_color_code: "#99439D",
        inner_color_code: "#CCA3CF",
      },
    },
    {
      id: 11,
      name: "Miscellaneous",
      color: {
        id: 11,
        color_code: "#F0EADB",
        outer_color_code: "#C9C4B4",
        inner_color_code: "#F0EADB",
      },
    },
  ],
  myCustomColors: [],
};

// Reducer function
const categoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_MY_COLORS:
      return {
        ...state,
        myCustomColors: action.payload,
      };
    case types.ADD_CUSTOM_COLOR_SUCCESS:
      return {
        ...state,
        myCustomColors: [...state.myCustomColors, action.payload],
      };
    case types.EDIT_CUSTOM_COLOR_SUCCESS:
      return {
        ...state,
        myCustomColors: state.myCustomColors.map((colorObj) =>
          colorObj.id === action.payload.id
            ? { ...colorObj, ...action.payload }
            : colorObj
        ),
      };
    case types.DELETE_CUSTOM_COLOR_SUCCESS:
      return {
        ...state,
        myCustomColors: state.myCustomColors.filter(
          (color) => color.id !== action.payload
        ),
      };
    case types.RESET_CATEGORY_COLORS:
      // Reset state to initial state
      return initialState;
    default:
      return state;
  }
};

export default categoryReducer;
